/** Whole minutes as words: "25 min", "1 h 05 min". Under a minute is "under a minute", so a short wait is never shown as zero. */
export function durationText(seconds: number): string {
  const minutes = Math.round(Math.abs(seconds) / 60);
  if (minutes < 1) return 'under a minute';
  if (minutes < 60) return `${minutes} min`;
  const rest = minutes % 60;
  return rest === 0 ? `${Math.floor(minutes / 60)} h` : `${Math.floor(minutes / 60)} h ${String(rest).padStart(2, '0')} min`;
}
